import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";

const VendorList = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);
    setSelectedData(data);

    setIsModalOpen(true);
  };
  const { addForm, update, sId } = props;

  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getVendor } = useHttp();
  const loadData = () => {
    setDataLoading(true)
    getVendor(
      {
        url: `/api/addVendor/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("addVendor", res);
        if (res) {
          setData(res);
          setDataLoading(false)
          setAllData(res);
        }
      
      },()=>{
        setDataLoading(false)
      }
    );
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    // //console.log(filetrtext);

    var filterdata =
      allData &&
      allData.filter(
        (item) =>
          item?.vendorCode?.includes(filetrtext) ||
          item?.vendorName?.includes(filetrtext) ||
          item?.contactPersonName?.includes(filetrtext)
      );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteVendor } = useHttp();

  useEffect(() => {
    loadData();
  }, []);

  const deleteData = (vendorId) => {
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Vendor detail?",
      onOk() {
        setDeleteLoading(true);
        deleteVendor(
          {
            url: "/api/addVendor/",
            method: "DELETE",
            body: {
              vendorId,
              orgId: parseInt(localStorage.getItem("orgId")),
              serviceId,
              createdBy: parseInt(localStorage.getItem("id")),
            },
          },
          (res) => {
            // //console.log(res);
            toast.success(res);
            loadData();
            setDeleteLoading(false);
          },
          () => {
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Vendor/Supplier</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2 mx-4"
              onClick={() => {
                addForm(true);
                sId(serviceId);
                props.update(false);
              }}
            >
              Add Vendor
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row ">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                      </div>
                    </div>
                    <br />
                    {dataLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "200px",
                        }}
                      > 
                      <h3 className="text-center">Loading...</h3>
                        <Spin size="large" />
                      </div>
                    ) : data &&data.length === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "200px",
                          fontWeight: "bold",
                        }}
                      >
                        No Data Found
                      </div>
                    ) : (
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Profile Image</th>
                            <th>Vendor Code</th>
                            <th>Vender Name</th>
                            <th>Contact Person Name</th>
                            <th>Total Order Value</th>
                            <th>Balance Due</th>

                            {canView === "block" && <th>View</th>}

                            {canEdit === "block" && <th>Edit</th>}
                            {canDelete === "block" && <th>Delete</th>}
                          </tr>
                        </thead>

                        <tbody>
                          {currentItems &&
                            currentItems.map((itm, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.profileUrl}`}
                                      className="user-image img-circle"
                                      width="60"
                                      height="60"
                                      alt="User Image"
                                    />
                                  </td>
                                  <td>{itm.vendorCode}</td>
                                  <td>{itm.vendorName}</td>
                                  <td>{itm.contactPersonName}</td>
                                  <td>{itm.totalOrderValue}</td>
                                  <td>{itm.balanceDue}</td>
                                  {canView === "block" && (
                                    <td>
                                      <button
                                        type="button"
                                        onClick={() => openModal(itm)}
                                        className="btn"
                                      >
                                        {" "}
                                        <i className="fas fa-eye"></i>
                                      </button>
                                    </td>
                                  )}
                                  {canEdit === "block" && (
                                    <td>
                                      <button
                                        onClick={() => {
                                          props.addForm(true);
                                          sId(serviceId);
                                          props.update(itm);
                                        }}
                                        className="btn"
                                      >
                                        <i className="fas fa-edit"></i>
                                      </button>
                                    </td>
                                  )}
                                  {canDelete === "block" && (
                                    <td>
                                      <button
                                        type="button"
                                        onClick={(e) =>
                                          deleteData(itm.vendorId)
                                        }
                                        className="btn"
                                        disabled={deleteLoading}
                                      >
                                        {deleteLoading ? (
                                          <Spin size="small" />
                                        ) : (
                                          <i className="fa fa-trash"></i>
                                        )}
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    )}
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={(data && data.length) || 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Vendor Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Vendor Code: {selectedData.vendorCode}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Vendor Name: {selectedData.vendorName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                contact Person Name: {selectedData.contactPersonName}
              </p>
              <p className="col-md-6">Email : {selectedData.email}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Work Contact Number : {selectedData.contactWork}
              </p>

              <p className="col-md-6">
                whatsapp Number: {selectedData.whatsapp}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Status : {selectedData.status}</p>

              <p className="col-md-6">
                payment Terms(In Days): {selectedData.paymentTermsDays}
              </p>
            </div>
            <h5 className="card-title">Associated Services</h5>
            <br />
            <div className="row">
              {selectedData.is_goodsSupplier && (
                <div className="col-md-3">
                  <p className="card-title" htmlFor="goods_supplier">
                    &bull; Goods Supplier
                  </p>
                  <br />
                </div>
              )}
              {selectedData.is_workServiceProvider && (
                <div className="col-md-4">
                  <p className="card-title" htmlFor="work_service_provider">
                    &bull; Work Service Provider
                  </p>{" "}
                  <br />
                </div>
              )}
              {selectedData.is_machinServices && (
                <div className="col-md-4">
                  <p
                    className="card-title"
                    htmlFor="machine_vehicle_equipement"
                  >
                    &bull; Machine/Vehicle
                  </p>
                </div>
              )}
              {selectedData.is_mainteinance && (
                <div className="col-md-4">
                  <p className="card-title" htmlFor="maintenance">
                    &bull; Maintenance
                  </p>
                  <br />
                </div>
              )}
              {selectedData.is_labourServices && (
                <div className="col-md-4">
                  <p className="card-title" htmlFor="Labour Services">
                    &bull;Labour Services
                  </p>
                  <br />
                </div>
              )}
            </div>
            <br />
            <h5 className="card-title">Vendor Address Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Address Type</th>
                  <th>Address(landmark)</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Registered</td>
                  <td>{selectedData.registeredAddress}</td>
                  <td>{selectedData.vendorCity}</td>
                  <td>{selectedData.vendorState}</td>
                  <td>{selectedData.vendorzipCode}</td>
                  <td>{selectedData.vendorCountry}</td>
                </tr>
                <tr>
                  <td>Office</td>
                  <td>{selectedData.officeAddress}</td>
                  <td>{selectedData.officeCity}</td>
                  <td>{selectedData.officeState}</td>
                  <td>{selectedData.officezipCode}</td>
                  <td>{selectedData.officeCountry}</td>
                </tr>
              </tbody>
            </table>
            <h5 className="card-title">Vendor Bank Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{selectedData.bankAcNo}</td>
                  <td>{selectedData.AccountHolderName}</td>
                  <td>{selectedData.IFSC}</td>
                </tr>
              </tbody>
            </table>{" "}
            {/**/}
          </div>
        )}
      </Modal>
    </>
  );
};

export default VendorList;
